"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Services_1 = require("../../Services");
var LicenseError = /** @class */ (function (_super) {
    __extends(LicenseError, _super);
    function LicenseError(props) {
        return _super.call(this, props) || this;
    }
    LicenseError.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Jumbotron, null,
                React.createElement("h1", { className: "display-3" }, this.props.resources.LicenseError_Title),
                React.createElement("p", { className: "lead" }, this.props.resources.LicenseError_Message1),
                React.createElement("hr", { className: "my-2" }),
                React.createElement("p", null, this.props.resources.LicenseError_Message2),
                React.createElement("p", { className: "lead" },
                    React.createElement(reactstrap_1.Button, { color: "primary", onClick: Services_1.Auth.logout }, this.props.resources.LogOut)))));
    };
    return LicenseError;
}(React.Component));
exports.LicenseError = LicenseError;
//# sourceMappingURL=LicenseError.js.map